import { create } from 'zustand';
import type { SortEvent, Metrics } from './core/types';

interface SortStore {
  events: SortEvent[];
  metrics: Metrics;
  isPlaying: boolean;
  currentEventIndex: number;
  setEvents: (events: SortEvent[]) => void;
  setMetrics: (metrics: Metrics) => void;
  setIsPlaying: (isPlaying: boolean) => void;
  setCurrentEventIndex: (index: number) => void;
}

export const useSortStore = create<SortStore>((set) => ({
  events: [],
  metrics: {
    comparisons: 0,
    swaps: 0,
    overwrites: 0,
    arrayAccesses: 0,
    recursionDepth: 0,
    eventCount: 0,
    memoryEstimate: 0,
  },
  isPlaying: false,
  currentEventIndex: 0,
  setEvents: (events) => set({ events }),
  setMetrics: (metrics) => set({ metrics }),
  setIsPlaying: (isPlaying) => set({ isPlaying }),
  setCurrentEventIndex: (currentEventIndex) => set({ currentEventIndex }),
}));
